import client from "libs/HttpClient";

/**
 * Service class for handling payment.
 */
class GogglePayPaymentService {
  /**
   * Adds a new Goggle pay Payment record based on the provided request.
   *
   * @param request - The request parameters for adding a Goggle pay payment record.
   * @returns A Promise that resolves to the Axios response for the add Goggle pay payment request record.
   */
  static completeGogglePayPayment(request: any) {
    return client.post("admin/goggle-pay/goggle-pay-success", request);
  }

  /**
   * Adds a new User Goggle pay Payment record based on the provided request.
   *
   * @param request - The request parameters for adding User a Goggle pay payment record.
   * @returns A Promise that resolves to the Axios response for the User add Goggle pay payment request record.
   */
  static userCompleteGogglePayPayment(request: any) {
    return client.post("admin/goggle-pay/user-pay-success", request);
  }
}

export { GogglePayPaymentService };
